import apiClient from './apiClient';

const profileApi = {
  createProfile: (formData: FormData) =>
    apiClient.post('/profiles', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  getMyProfile: () => apiClient.get('/profiles/me').then((r) => r.data),

  updateMyProfile: (data: FormData | Record<string, unknown>) =>
    apiClient.patch('/profiles/me', data, {
      headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
    }).then((r) => r.data),

  addGalleryImage: (formData: FormData) =>
    apiClient.post('/profiles/me/images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  removeGalleryImage: (index: number) =>
    apiClient.delete(`/profiles/me/images/${index}`).then((r) => r.data),

  getProfileById: (id: string) =>
    apiClient.get(`/profiles/${id}`).then((r) => r.data),

  rateProfile: (id: string, rating: number) =>
    apiClient.post(`/profiles/${id}/rate`, { rating }).then((r) => r.data),
};

export default profileApi;
